export default __webpack_public_path__ + "static/media/personality_ISFp.7dc7578b.png";